import { useState } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "";

/**
 * Google Auth button — kicks off our own backend Google OAuth flow.
 * Backend endpoint /api/auth/google/start redirects to Google, then
 * Google calls back to /api/auth/google/callback which sets auth and
 * redirects back to the frontend dashboard/onboarding.
 */
export default function GoogleAuthButton({ label = "Continue with Google", testid = "google-auth-button" }) {
  const [busy, setBusy] = useState(false);

  const onClick = () => {
    setBusy(true);
    // Hit our backend OAuth start endpoint (full page redirect)
    window.location.href = `${API_BASE}/api/auth/google/start`;
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      data-testid={testid}
      className="w-full py-3 flex items-center justify-center gap-3 border border-border bg-white text-obsidian font-app font-medium hover:bg-card transition-colors disabled:opacity-60"
    >
      <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#FFC107" d="M43.6 20.5h-1.9V20H24v8h11.3c-1.7 4.7-6.2 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 13 4 4 13 4 24s9 20 20 20 20-9 20-20c0-1.3-.1-2.3-.4-3.5z"/>
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 16 18.9 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
        <path fill="#4CAF50" d="M24 44c5.2 0 9.8-2 13.4-5.3l-6.2-5.2c-2 1.4-4.6 2.3-7.2 2.3-5.1 0-9.5-3.3-11.2-7.9l-6.5 5C9.4 39.6 16.1 44 24 44z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.1 5.6l6.2 5.2C40.9 36 44 30.5 44 24c0-1.3-.1-2.3-.4-3.5z"/>
      </svg>
      <span>{busy ? "Redirecting…" : label}</span>
    </button>
  );
}
